/* eslint-disable max-len */
export class TooltipUtils {
    static defaultTooltipConfig = {
        trigger: 'hover',
        delay: { show: 650, hide: 100 }
    };
    // Make sure this is initialized only once
    private static tooltipsInitialized = false;

    static initToolTips(config?: any, whiteStyle?: boolean): void {
        if (!TooltipUtils.tooltipsInitialized) {
            if (whiteStyle) {
                $('html > head').append($(
                    '<style>' +
                    '.tooltip-inner {background-color: white !important;color: #323A45FF !important;box-shadow: 0 0 25px rgba(0, 0, 0, .2);width: max-content;} ' +
                    '.tooltip.top .tooltip-arrow {color: white !important; border-top-color: white !important;}' +
                    '.tooltip.bottom .tooltip-arrow {color: white !important; border-bottom-color: white !important;}' +
                    '.tooltip.left .tooltip-arrow {color: white !important; border-left-color: white !important;}' +
                    '.tooltip.right .tooltip-arrow {color: white !important; border-right-color: white !important;}' +
                    '</style>'));
            }
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            // @ts-ignore
            [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, config || TooltipUtils.defaultTooltipConfig));
            TooltipUtils.tooltipsInitialized = true;
        }
    }

    static hideAllTooltips(): void {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        // @ts-ignore
        [...tooltipTriggerList].map(tooltipTriggerEl => bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl).hide());
    }

    static showTooltip(tooltipId): void {
        // @ts-ignore
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(`#${tooltipId}`); // Returns a Bootstrap tooltip instance
        tooltip.show();
    }

    static changeTitle(tooltipId, title): void {
        // @ts-ignore
        const tooltip = bootstrap.Tooltip.getOrCreateInstance(`#${tooltipId}`); // Returns a Bootstrap tooltip instance
        tooltip.setContent({ '.tooltip-inner': title });
    }
}
